/**
 * Personel kaydındaki çoklu alanlar için küçük yardımcılar.
 *
 * Arka uç personeli `departments` / `tags` / `roles` gibi zenginleştirilmiş
 * `{value,label}` listeleriyle döndürüyor. Eskiden panelde tek değerli
 * `employee.department` ve `employee.position` alanları okunuyordu — bu alanlar
 * ne TS tipinde ne Mongo şemasında var, model çoklu departman + etiket düzenine
 * geçerken geride kalmışlar.
 */

type Selectable = { value?: unknown; label?: string } | null | undefined;

/** `{value,label}` listesini "Üretim, Depo" metnine çevirir. */
export const labelList = (
  items: Selectable[] | null | undefined,
  empty: string = "—"
): string => {
  const labels = (items ?? [])
    .map((item) => item?.label)
    .filter((label): label is string => Boolean(label));
  return labels.length > 0 ? labels.join(", ") : empty;
};

/** Listede seçili id var mı? (departman/etiket filtreleri için) */
export const hasSelected = (
  items: Selectable[] | null | undefined,
  selected: unknown
): boolean => {
  if (!selected) return true;
  return (items ?? []).some(
    (item) => String(item?.value) === String(selected)
  );
};
